import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import BusinessCardFront from './components/BusinessCardFront';
import BusinessCardBack from './components/BusinessCardBack';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    join_code: PropTypes.string,
    is_web_gallery: PropTypes.bool,
    album_subtype: PropTypes.string.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    id: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    logo_image: PropTypes.shape({
      url: PropTypes.string,
    }),
  }).isRequired,
};

const AccountMarketingMaterialBusinessCardPrintTemplate = ({
  account,
  albumFolder,
}) => {
  return (
    <Fragment>
      <div className="marketing-material-business-card-page">
        <p className="marketing-material-business-card-page-label">FRONT</p>
        <BusinessCardFront account={account} />
        <BusinessCardFront account={account} />
        <BusinessCardFront account={account} />
        <BusinessCardFront account={account} />
        <BusinessCardFront account={account} />
        <BusinessCardFront account={account} />
        <BusinessCardFront account={account} />
        <BusinessCardFront account={account} />
      </div>
      <div className="marketing-material-business-card-page">
        <p
          className="marketing-material-business-card-page-label label-back"
          style={{ top: '51%' }}
        >
          BACK
        </p>
        <BusinessCardBack albumFolder={albumFolder} />
        <BusinessCardBack albumFolder={albumFolder} />
        <BusinessCardBack albumFolder={albumFolder} />
        <BusinessCardBack albumFolder={albumFolder} />
        <BusinessCardBack albumFolder={albumFolder} />
        <BusinessCardBack albumFolder={albumFolder} />
        <BusinessCardBack albumFolder={albumFolder} />
        <BusinessCardBack albumFolder={albumFolder} />
      </div>
    </Fragment>
  );
};

AccountMarketingMaterialBusinessCardPrintTemplate.propTypes = propTypes;

export default AccountMarketingMaterialBusinessCardPrintTemplate;
